import React, { Component } from 'react';

import Grid from '../Helper/Grid'
import GridFilter from '../Helper/GridFilter'
import DonneurOrdre from '../Entity/DonneurOrdre'

/**
* Class DonneurOrdreList
* DonneurOrdreList view component
**/
class DonneurOrdreList extends Component {

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {
    const objectClass = DonneurOrdre;

    // Filter list
    const filters = [{
      title: "Nom du donneur d'ordre",
      type: "text",
      name: "libelleDonneurOrdre",
      rowIdx: 1
    }];

    // Rendering the view
		return (
      <div className="searchContainer">
        <h2>Gérer les donneurs d'ordre</h2>
        <GridFilter title="Filtrer les donneurs d'ordre" objectClass={objectClass.getClassName()} filters={filters} parent={this} formattedFilters={true} />
        <Grid title="Donneurs d'ordre" ref={"grid" + objectClass.name} path="donneurordres" objectPath="donneurordres" objectClass={objectClass} height="400px" hidden={false} />
      </div>
		);
	}

  /**
  * applyFilter
  * Filters the grid
  **/
  applyFilter(fieldName, value) {
    const grid = this.refs["grid" + DonneurOrdre.name];
    grid.applyFilter(fieldName, value);
  }

  /**
  * clearFilters
  * Clear the filters
  **/
  clearFilters() {
    const grid = this.refs["grid" + DonneurOrdre.name];
    grid.clearFilters();
  }

}
export default DonneurOrdreList;



// WEBPACK FOOTER //
// ./src/views/Search/DonneurOrdreList.js